import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Container,
    Card,
    CardContent,
    CircularProgress,
    List,
    ListItem,
} from "@mui/material";

function Utilities() {
    const [utilities, setUtilities] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios({
            method: "GET",
            url: "/files/industries/utilities.txt",
        }).then((res) => {
            setUtilities(res.data);
            setLoading(false);
        });
    }, []);

    return (
        <Container maxWidth="md" sx={{ py: 2 }}>
            {/* Page Title */}
            <Typography
                variant="h3"
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mt: 7,
                    fontSize: {
                        xs: "1.8rem",  // mobile (~h4)
                        sm: "2.2rem",  // tablet (~h3)
                        md: "2.8rem",  // laptop (~h3+)
                        lg: "3rem",    // desktop (~h2)
                    },
                }}
            >
                Utilities
            </Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress color="secondary" />
                </Box>
            ) : (
                <>
                    {utilities &&
                        utilities.map((data, index) => (
                            <Box key={index} mb={3}>
                                {Array.isArray(data) ? (
                                    <>
                                        <Typography
                                            variant="h6"
                                            sx={{ fontWeight: "600", color: "#030366", mb: 1 }}
                                        >
                                            VENSYX Data Solutions for Utilities
                                        </Typography>
                                        <List sx={{ pl: 3 }}>
                                            {data.map((subItem, subIndex) => (
                                                <ListItem
                                                    key={subIndex}
                                                    sx={{
                                                        display: "list-item",
                                                        listStyleType: "disc",
                                                        pl: 1,
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    {subItem}
                                                </ListItem>
                                            ))}
                                        </List>
                                    </>
                                ) : (
                                    <Typography
                                        variant="body1"
                                        sx={{ mb: 2, textAlign: "justify", fontSize: "18px" }}
                                    >
                                        {data}
                                    </Typography>
                                )}
                            </Box>
                        ))}
                </>
            )}
        </Container>
    );
}

export default Utilities;
